import { render, staticRenderFns } from "./FavRow.vue?vue&type=template&id=f945f816&scoped=true"
import script from "./FavRow.vue?vue&type=script&lang=js"
export * from "./FavRow.vue?vue&type=script&lang=js"
import style0 from "./FavRow.vue?vue&type=style&index=0&id=f945f816&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f945f816",
  null
  
)

export default component.exports